import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { campaignsApiPath } from './apiPath';
import {
  SeedingMutationContentTypeSchema,
  SeedingMutationSnsChannelSchema,
} from './seedingMutationSchemas';

const SubmitSeedingContentRequestSchema = z
  .object({
    participationId: z.number().int(),
    channel: SeedingMutationSnsChannelSchema,
    contentType: SeedingMutationContentTypeSchema,
    contentUrl: z.string(),
  })
  .describe('SubmitSeedingContentRequest');

export type SubmitSeedingContentRequest = z.infer<typeof SubmitSeedingContentRequestSchema>;

// NOTE: swagger 상 204 No Content. 응답 형태 미확정 — unknown 으로 통과. BE 연동 시 재확인.
const SubmitSeedingContentResponseSchema = z.unknown().describe('SubmitSeedingContentResponse');

export type SubmitSeedingContentResponse = z.infer<typeof SubmitSeedingContentResponseSchema>;

export const submitSeedingContent = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(SubmitSeedingContentRequestSchema),
    async ({
      participationId,
      channel,
      contentType,
      contentUrl,
    }: SubmitSeedingContentRequest): Promise<SubmitSeedingContentResponse> =>
      executeStandardRequest(async () =>
        privateHttpClient.post<SubmitSeedingContentResponse>(
          urlJoin(campaignsApiPath.submitSeedingContent(participationId)),
          { channel, contentType, contentUrl },
          // 204 No Content 빈 본문 JSON 파싱 throw 방지 (성공인데 실패 처리 방지). (SID-4053 동류)
          { responseType: 'text' },
        ),
      ),
    validateApiResponse(SubmitSeedingContentResponseSchema),
  ),
);
